import { HttpParams } from '@angular/common/http';

export type QueryParams = Record<string, string>;

export function stringifyQueryParams(queryParams: QueryParams): string {
  let httpParams = new HttpParams();
  Object.keys(queryParams).forEach((key) => (httpParams = httpParams.append(key, queryParams[key])));

  return httpParams.toString();
}
